import { handleServiceError } from '../helpers/app';
import apiRequest from './apiService';

/**
 * @param userId: string - is used to filter the agent roles accessible to the user.
 */
export const getAgentRoles = async (userId: string) => {
  try {
    const result = await apiRequest(
      'agent',
      'GET',
      `/agent/get_user_agent_roles/${userId}`
    );
    return result;
  } catch (err: unknown) {
    handleServiceError(err, 'agent');
  }
};

export const getAgentRole = async (roleId: string) => {
  try {
    const result = await apiRequest(
      'agent',
      'GET',
      `/agent/get_agent_role/${roleId}`
    );
    return result;
  } catch (err: unknown) {
    handleServiceError(err, 'agent');
  }
};
